import { IoMdClose } from "react-icons/io";
import Modal from "react-modal";
import "../styles/style.css";
import { useEffect, useState } from "react";

type FiltroPesquisa = {
  titulo: string;
  status: "Ativo" | "Inativo" | ""; 
  criadoDe: string;    
  criadoAte: string; 
};

type ModalFilterProps = {
  stateModal: boolean;
  close?: () => void;
  filtros: FiltroPesquisa;
  onApply: (f: FiltroPesquisa) => void;
};

export const ModalFilter = ({ stateModal, close, filtros, onApply }: ModalFilterProps) => {
  const [titulo, setTitulo] = useState(filtros.titulo);
  const [status, setStatus] = useState<FiltroPesquisa["status"]>(filtros.status || "");
  const [criadoEm, setCriadoEm] = useState(filtros.criadoDe);
  const [dataFim, setDataFim] = useState(filtros.criadoAte);

  const modal_header_text = "Filtros";

  useEffect(() => {
    if (!stateModal) return;
    setTitulo(filtros.titulo || "");
    setStatus(filtros.status || "");
    setCriadoEm(filtros.criadoDe || "");
    setDataFim(filtros.criadoAte || "");
  }, [stateModal, filtros]);

  const clearInputs = () => {
    setTitulo("");
    setStatus("");
    setCriadoEm("");
    setDataFim("");

    onApply({
      titulo: "",
      status: "",
      criadoDe: "",
      criadoAte: "",
    });
  };

  const handleApply = () => {
    onApply({
      titulo,
      status,
      criadoDe: criadoEm,
      criadoAte: dataFim
    });
    close?.();
  };

  return (
    <Modal
      isOpen={stateModal}
      onRequestClose={close}
      ariaHideApp={false}
      contentLabel="Selected Option"
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#262626CC",
          zIndex: 1001,
        },
        content: {
          width: "40%",
          height: "40%",
          margin: "0 auto",
          border: "1px solid #ccc",
          background: "#fff",
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          borderRadius: "4px",
          outline: "none",
          padding: "20px",
          zIndex: 1001,
        },
      }}
    >
      <div className="headerform" style={{ marginBottom: "20px" }}>
        <span style={{ color: "#1f3564", fontSize: "20px" }}>
          {modal_header_text}
        </span>
        <span
          style={{
            position: "absolute",
            right: "1%",
            top: "1%",
            fontSize: "16px",
            cursor: "pointer",
          }}
          onClick={close}
        >
          <IoMdClose />
        </span>
      </div>

      <div className="containerInputs">
        <div className="form-grid">
          <div className="form-group">
            <span className="form-label">Título</span>
            <input
              type="text"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              className="form-control"
              placeholder="Digite aqui"
            />
          </div>

          <div className="form-group">
            <span className="form-label">Status</span>
            <select
              className="form-control"
              value={status}
              onChange={(e) =>
                setStatus(e.target.value as FiltroPesquisa["status"])
              }
            >
              <option value="">Todos</option>
              <option value="Ativa">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
          </div>

          <div className="form-group">
            <span className="form-label">Criado em (início)</span>
            <input
              type="date"
              value={criadoEm}
              onChange={(e) => setCriadoEm(e.target.value)}
              className="form-control"
              placeholder="ínicio (dd/MM/yyyy)"
            />
          </div>

          <div className="form-group">
            <span className="form-label">Criado em (fim)</span>
            <input
              type="date"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
              className="form-control"
              placeholder="fim (dd/MM/yyyy)"
            />
          </div>
        </div>

        <div className="containerButtonsModal">
          <div className="containerContentButtons">
            <button
              style={{ marginRight: "10px" }}
              className="btn btn-outline-primary btn-sm"
              onClick={clearInputs}
            >
              Limpar
            </button>
            <button
              className="btn btn-primary btn-sm"
              onClick={handleApply}
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalFilter;
